import Icon from 'components/Icon';
import classNames from 'classnames';
import {ChangeEvent, FC, MouseEvent, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';

interface ISelectSearchProps {
    isNothingFound?: boolean;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onClear: (e: MouseEvent<HTMLButtonElement>) => void;
    placeholder: string;
}

export const FilterSearch: FC<ISelectSearchProps> = ({isNothingFound, onChange, onClear, placeholder}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [value, setValue] = useState('');

    const handleBlur = () => {
        setIsFocused(false);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        onChange(e);
    };

    const handleClear = (e: MouseEvent<HTMLButtonElement>) => {
        setValue('');
        onClear(e);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    return (
        <div className={isNothingFound ? style.isNothingFound : ''}>
            <div
                data-skeleton-item={true}
                className={classNames(style.main, {
                    [style.hasValue]: Boolean(value),
                    [style.isFocused]: isFocused,
                })}
            >
                <input
                    className={style.input}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    placeholder={placeholder}
                    type={'text'}
                    value={value}
                />
                <button className={style.closeButton} onClick={handleClear} type={'button'}>
                    <Icon className={style.iconClose} icon={'close'} />
                </button>
            </div>
            <Typography className={style.notFoundMessage} element={'div'} variant={'label-12-r'}>
                Ничего не найдено
            </Typography>
        </div>
    );
};
